import { Inject } from '@odinjs/odin';
import { ActionAPI, FormAPI, InputAPI, ModalService, TextAreaAPI, ToastService } from '@philips-internal/oswald-ui-components';
import { Placement, ToastLevel, ToastType } from '@philips-internal/oswald-ui-constants';
import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';

import { FragmentNames, MessageItemAliases } from '../../codegen';
import { Message, MessageVO } from '../../interfaces';
import { MessagesService } from '../../services';
import BaseController from '../BaseController';

@Controller({ fragment: FragmentNames.MESSAGE_ITEM })
export default class MessageItemController extends BaseController {

  @Inject(MessageItemAliases.FORM_MESSAGE)
  formMessage!: FormAPI;

  @Inject(MessageItemAliases.INPUT_MESSAGE_ITEM_SUBJECT)
  inputSubject!: InputAPI;

  @Inject(MessageItemAliases.TEXT_AREA_MESSAGE_ITEM_MESSAGE)
  inputMessage!: TextAreaAPI;

  @Inject(MessageItemAliases.ACTION_FILES)
  actionFiles!: ActionAPI;

  id!: string | number;
  message!: Message;

  @OnMount({ target: MessageItemAliases.FORM_MESSAGE })
  onMountFormMessageItem(): void {
    this.id = this.getPathId();
    const messageSubject = this.formMessage.getData().messageSubject as string;
    this.formMessage.setLoading(true);
    void MessagesService.find(this.id).then((response: MessageVO) => {
      this.message = response.message;
      this.formMessage.setData({
        messageSubject: response.message.messageSubject,
        messageDescription: response.message.messageDescription,
      });
      this.formMessage.setLoading(false);
      this.formMessage.setDisabled(true);
      this.inputSubject.setReadOnly(true);
      this.inputMessage.setReadOnly(true);

      const filesCount = this.message.attachments.length;
      if (filesCount === 0) {
        this.actionFiles.setEnabled(false);
      }

      if (!response.read) {
        void MessagesService.update(this.id).then();
      }
    }).catch(error => {
      this.showErrorMessage(error.status, messageSubject);
    });
  }

  @OnClick(MessageItemAliases.ACTION_FILES)
  onClickActionFiles(): void {
    ModalService.openDialog({
      id: 'files',
      fragment: 'files-list',
      contextData: {
        data: this.message?.attachments,
        messageId: this.id,
      },
    });
  }

  private showErrorMessage = (status: number, messageSubject: string): void => {
    this.formMessage.setLoading(false);
    this.formMessage.setEditing(true);
    const message = MessageService.translate(status === 404 ? 'message.error-not-found' : 'message.error-unexpected-create');
    ToastService.open({
      dismissible: false,
      id: 'save-error',
      message,
      placement: Placement.TOP,
      showIcon: true,
      level: ToastLevel.ERROR,
      title: messageSubject,
      type: ToastType.BUBBLE,
    });
  };

}
